import './horizontal-line.scss';

function HorizontalLine() {
    return (
        <div className="horizontal-line"></div>
    );
}

export default HorizontalLine;
